import React from 'react';
import { Tooltip, Box, Typography, makeStyles, withStyles } from '@material-ui/core';
import { getRecipeInfo } from './recipeStructureData';

// Fields shown in the hover card (order matches the recipe structure / design).
const FIELDS = [
  ['Batch Number', 'batchNumber'],
  ['Unit Name', 'unitName'],
  ['Unit Procedure', 'unitProcedure'],
  ['Operation', 'operation'],
  ['Phase', 'phase'],
  ['Start Time', 'startTime'],
  ['End Time', 'endTime'],
];

// Light, bordered tooltip card (overrides MUI's default dark tooltip).
const RecipeTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#333',
    border: '1px solid #d3d7de',
    borderRadius: 4,
    boxShadow: '0 6px 20px rgba(0,0,0,0.18)',
    maxWidth: 360,
    padding: 0,
  },
}))(Tooltip);

const useStyles = makeStyles(() => ({
  procLink: {
    borderBottom: '1px dashed #9aa0ad',
    cursor: 'help',
    whiteSpace: 'nowrap',
  },
  card: { padding: '10px 14px' },
  row: { display: 'flex', alignItems: 'flex-start', padding: '2px 0' },
  label: {
    width: 96,
    minWidth: 96,
    fontSize: '0.72rem',
    fontWeight: 700,
    color: '#222',
    lineHeight: 1.4,
  },
  value: { fontSize: '0.72rem', color: '#555', lineHeight: 1.4, flex: 1, wordBreak: 'break-word' },
}));

// Renders a Procedure Number. When it maps to a recipe-structure row for the
// current batch, it becomes a hover target showing the ISA-88 detail card;
// otherwise it renders as plain text.
const ProcedureNumberCell = ({ value, batchNumber }) => {
  const classes = useStyles();
  if (value == null || value === '') return null;

  const info = getRecipeInfo(batchNumber, value);
  if (!info) return <span>{value}</span>;

  const content = (
    <Box className={classes.card}>
      {FIELDS.map(([label, key]) => (
        <Box key={key} className={classes.row}>
          <Typography className={classes.label}>{label}</Typography>
          <Typography className={classes.value}>{info[key] || '—'}</Typography>
        </Box>
      ))}
    </Box>
  );

  return (
    <RecipeTooltip title={content} placement="right-start" interactive enterTouchDelay={0}>
      <span className={classes.procLink}>{value}</span>
    </RecipeTooltip>
  );
};

export default ProcedureNumberCell;
